import { render, staticRenderFns } from "./MultimediaSource.vue?vue&type=template&id=2072fab4&scoped=true"
import script from "./MultimediaSource.vue?vue&type=script&lang=js"
export * from "./MultimediaSource.vue?vue&type=script&lang=js"
import style0 from "./MultimediaSource.vue?vue&type=style&index=0&id=2072fab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2072fab4",
  null
  
)

export default component.exports